export const updatedAt = (dateObj, selfTrackingFlag) => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ];
  const currentDateObj = new Date();
  let displayString;
  const diff = Math.abs(currentDateObj - dateObj);
  const minutes = Math.floor(diff / 1000 / 60);
  if (minutes < 60 && !selfTrackingFlag) {
    displayString = `${minutes} minutes ago`;
  } else if (minutes === 60 && !selfTrackingFlag) {
    displayString = 'Updated an hour ago';
  } else {
    let day = dateObj.getDate();
    if (day <= 9) day = `0${day}`;
    const month = monthNames[dateObj.getMonth()];
    const year = dateObj.getFullYear().toString().substr(-2);
    let hours = dateObj.getHours();
    let dateObjMinutes = dateObj.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours %= 12;
    hours = hours || 12;
    dateObjMinutes =
      dateObjMinutes < 10 ? `0${dateObjMinutes}` : dateObjMinutes;
    const timeString = `${hours}:${dateObjMinutes} ${ampm}`;
    const dateString = `${day} ${month} ${year}`;
    displayString = `${dateString}, ${timeString}`;
  }
  return displayString;
};
export default updatedAt;
